// @ts-ignore
import { FunctionComponent, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Layout } from 'components/Layout/Layout';
import Head from 'next/head';
import { Consts } from 'styles/consts';
import { ColorDefs } from 'styles/colorDefs';
import styled from 'styled-components';
import { Footer } from 'components/Layout/Footer';
import { Header } from 'components/Layout/Header';
import { Student } from 'components/Registration/Student';
import { Teacher } from 'components/Registration/Teacher';
import { Parent } from 'components/Registration/Parent';
import { ButtonTab } from 'components/Registration/ButtonTab';
import { FlexWrapper, FlexBox } from 'components/Layout/Flex';
import { ActionButton } from '../components/Buttons/ActionButton';
import { Spacer } from '../components/Layout/Spacer';
import { useOnce } from '../hooks/useOnce';
import { scrollTop } from '../utils';

const Registration: FunctionComponent = () => {
  const router = useRouter();
  const [type, setType] = useState('student');
  const [done, setDone] = useState(false);

  useOnce(() => {
    scrollTop();
  });

  useEffect(() => {
    if (done) {
      scrollTop();
    }
  }, [done]);

  useEffect(() => {
    if (router.query.type) {
      setType(router.query.type.toString());
    }
  }, [router]);

  useOnce(() => {
    router.push('/');
  });

  return null;

  // return (
  //   <Layout>
  //     <Head>
  //       <title>The Earth Prize - Registration</title>
  //       <meta
  //         name="description"
  //         content="Registration for The Earth Prize is open until Nov. 30th 2023. By registering, students and teachers get automatic access to The Earth Prize learning materials and mentoring by university students."
  //       />
  //       <meta property="og:title" content="The Earth Prize - Registration" />
  //       <meta
  //         property="og:description"
  //         content="Registration for The Earth Prize is open until Nov. 30th 2023. By registering, students and teachers get automatic access to The Earth Prize learning materials and mentoring by university students."
  //       />
  //       <meta property="og:image" content="/images/cover.jpg" />
  //     </Head>
  //     <Header />
  //     <FlexWrapperStyled>
  //       <FlexBox>
  //         <Spacer height={50} />
  //         {done ? (
  //           <Done>
  //             {type === 'parent' ? (
  //               <>
  //                 <span>Thank you!</span>
  //                 <br />
  //                 <br />
  //                 <span>
  //                   We have emailed your child and their tutor with instructions
  //                   on how to register for The Earth Prize competition.
  //                 </span>
  //                 <ActionButton
  //                   background="#00B7BC"
  //                   color="black"
  //                   onClick={() => router.push('/')}
  //                   style={{
  //                     marginTop: '30px',
  //                   }}
  //                 >
  //                   BACK TO HOMEPAGE
  //                 </ActionButton>
  //               </>
  //             ) : (
  //               <>
  //                 <span>
  //                   Congratulations on registering for The Earth Prize
  //                   competition!
  //                 </span>
  //                 <br />
  //                 <br />
  //                 <span>
  //                   Before you can access the platform, please verify your email
  //                   address to activate your account. If you did not receive an
  //                   email from us in the next few minutes, please check your
  //                   spam folder.
  //                 </span>
  //               </>
  //             )}
  //           </Done>
  //         ) : (
  //           <>
  //             <HeaderTitle>count me in</HeaderTitle>
  //             {(type === 'student' || type === 'teacher') && (
  //               <Info>
  //                 Both students and teachers need to register individually.
  //                 Teachers or team leaders will be in charge of creating the
  //                 teams on the platform.
  //               </Info>
  //             )}
  //             <Buttons>
  //               <ButtonTab
  //                 active={type === 'student'}
  //                 onClick={() => setType('student')}
  //               >
  //                 STUDENT
  //               </ButtonTab>
  //               <ButtonTab
  //                 active={type === 'parent'}
  //                 onClick={() => setType('parent')}
  //               >
  //                 PARENT
  //               </ButtonTab>
  //               <ButtonTab
  //                 active={type === 'teacher'}
  //                 onClick={() => setType('teacher')}
  //               >
  //                 TEACHER
  //               </ButtonTab>
  //             </Buttons>
  //             <FormControl>
  //               <FormInputWrapper>
  //                 <Type>I am a {type}</Type>
  //               </FormInputWrapper>
  //             </FormControl>
  //             {type === 'student' && <Student setDone={() => setDone(true)} />}
  //             {type === 'teacher' && <Teacher setDone={() => setDone(true)} />}
  //             {type === 'parent' && <Parent setDone={() => setDone(true)} />}
  //           </>
  //         )}
  //       </FlexBox>
  //       <FlexBox withoutPadding>
  //         <Image />
  //       </FlexBox>
  //     </FlexWrapperStyled>
  //     <Footer fullHeight />
  //   </Layout>
  // );
};

const FlexWrapperStyled = styled(FlexWrapper)`
  padding-top: 80px;
  min-height: 100vh;
  grid-template-columns: 3fr 2fr;

  @media (max-width: ${Consts.tabletBreakPoint}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${Consts.smallTabletBreakPoint}) {
    grid-template-columns: 1fr;
  }
`;

const Done = styled.div`
  color: ${ColorDefs.robinsEggBlue};

  > span {
    &:nth-child(1) {
      font-size: 46px;
      font-weight: bold;

      @media (max-width: ${Consts.mobileBreakPoint}) {
        font-size: 28px;
      }
    }
    &:nth-child(4) {
      font-size: 20px;

      @media (max-width: ${Consts.mobileBreakPoint}) {
        font-size: 16px;
      }
    }
  }
`;

const Image = styled.div`
  max-width: 580px;
  width: 100%;
  height: 100%;
  max-height: 500px;
  position: relative;
  background-image: url('/images/image69.webp');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: ${Consts.mobileBreakPoint}) {
    width: 80%;
    margin: 0 auto;
  }
`;

const HeaderTitle = styled.div`
  font-size: 35px;
  font-weight: bold;
  color: ${ColorDefs.robinsEggBlue};
  text-transform: uppercase;
  margin: 5px 5px 20px 5px;
`;

const Buttons = styled.div`
  display: flex;
  margin: 5px 5px 10px 5px;
  flex-wrap: wrap;
`;

const FormControl = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FormInputWrapper = styled.div`
  width: 100%;
  @media (min-width: ${Consts.tabletBreakPoint}) {
    width: 50%;
  }
`;

const Type = styled.div`
  flex-grow: 1;
  background: ${ColorDefs.robinsEggBlue};
  color: black;
  height: 40px;
  padding: 10px;
  margin: 5px 5px 10px;
  font-size: 16px;
  font-weight: 500;
  width: 170px;
  text-align: center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
`;

const Info = styled.div`
  color: #ceaa7a;
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 500;
`;

export default Registration;
